<template>
  <div
    class="br-pagebody pd-x-20 pd-sm-x-30"
    id="ShippingFeeList"
  >
    <div class="card bd-gray-400">
      <table class="table mg-b-0 table-contact bill data-table">
        <thead>
          <tr>
            <th class=" wd-200">{{$t("express.物流名称")}}</th>
            <th class="wd-lg-300">{{$t("express.支持国家")}}</th>
            <th class="wd-lg-300">{{$t("express.运费规则")}}</th>
            <th class=" wd-100">{{$t("express.状态")}}</th>
            <th class=" wd-100">{{$t("express.操作")}}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in items"
            :key="item.id"
          >
            <td class="valign-middle">
              <div class=" tx-white">{{item.logistics}}</div>
            </td>
            <td class=" valign-middle">
              <!--<div class="countrys-wrap tx-white">
                {{item.countrys | showCountrys}}
              </div>-->
              <div class="countrys-wrap tx-white" v-if="item.areaConfig && item.areaConfig.length">
              	<div v-for="(area,i) in item.areaConfig" :key="area.id+area.name" class="d-flex tx-white">
              		<span style="white-space: nowrap;">{{area.name}}:</span>
              		<div class="mg-l-10 tx-gray-600">{{area.countrys | showCountrys}}</div>
              	</div>
              </div>
            </td>
            <td class=" valign-middle">
            	<div class="countrys-wrap tx-white" v-if="item.areaConfig && item.areaConfig.length">
              	<div v-for="(area,i) in item.areaConfig" :key="area.id+area.name" class="d-flex tx-white">
              		<span style="white-space: nowrap;cursor: pointer;"  @mouseenter="popContact($event, area, 'editMobile')"
                      @mouseleave="popContact($event)">
              			<span class="mg-r-10">{{area.name}}:</span>
              			{{area.ruleType == 1 ? $t('express.按单收运费') : ''}}
                  	{{area.ruleType == 2 ? $t('express.按重量收运费') : ''}}
                  	{{area.ruleType == 3 ? $t('express.按件收运费') : ''}}
              		</span>
              	</div>
              </div>
              <div v-if="item.volumetricWeight">{{$t("express.体积重计算参数: ")}}<span class=" tx-white">{{item.volumetricWeight}}</span></div>
              <!--<div class=" mg-b-10 tx-white">
                <p class="mg-b-5">
                  {{item.ruleType == 1 ? '按单收运费' : ''}}
                  {{item.ruleType == 2 ? '按重量收运费' : ''}}
                  {{item.ruleType == 3 ? '按件收运费' : ''}}
                </p>
                <p
                  class="mg-b-5"
                  v-if="item.ruleType == '1'"
                >
                  每单{{item.ruleJson.everyFee}}元
                </p>
                <p
                  class="mg-b-5"
                  v-if="item.ruleType == '2'"
                >
                  <span class="mg-b-5 d-block">
                    首重{{item.ruleJson.startWeight}}克，运费{{item.ruleJson.startPrice}}元，
                  </span>
                  <span class="mg-b-5 d-block">
                    每续重{{item.ruleJson.incWeight}}克，运费加{{item.ruleJson.incPrice}}元，
                  </span>
                </p>
                <p
                  class="mg-b-5"
                  v-if="item.ruleType == '3'"
                >
                  <span class="mg-b-5 d-block">
                    首件，运费{{item.ruleJson.startPrice}}元，
                  </span>
                  <span class="mg-b-5 d-block">
                    后续每件，运费{{item.ruleJson.incPrice}}元，
                  </span>
                </p>
              </div>
              <div v-if="item.volumetricWeight">体积重计算参数: <span class=" tx-white">{{item.volumetricWeight}}</span></div>-->
            </td>
            <td class=" valign-middle">
              <span 
                :class="item.status == 1 ? 'tx-success' : 'tx-danger'">
                {{item.status == 1 ? $t('express.启动') : $t('express.停用')}}
              </span>
            </td>
            <td class=" valign-middle">
              <!--<div><a
                  class=" tx-info"
                  href="javascript:;"
                  @click="modiShipping(item)"
                >修改</a></div>-->
                <router-link class=" tx-info" target="_blank" :to="{name:'createShipping',query: {logistics: item.logistics}}">{{$t("express.修改")}}</router-link>
                <div v-if="item.status == 1"><a
                  class=" tx-danger"
                  href="javascript:;"
                  @click="changeStatus(item,2)"
                >{{$t("express.停用")}}</a></div>
              <div v-if="item.status == 2"><a
                  class=" tx-info"
                  href="javascript:;"
                  @click="changeStatus(item,1)"
                >{{$t("express.启用")}}</a></div>
              <div><a
                  class=" tx-danger"
                  href="javascript:;"
                  @click="delShipping(item)"
                >{{$t("express.删除")}}</a></div>
            </td>
          </tr>
          <tr v-if="(!items || items.length < 1) && !first_loading">
            <td colspan="5">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i>{{$t("express.没有符合条件的物流渠道")}}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["first_loading", "items"],
  filters: {
    showCountrys(val){
      let arr = [];
      val.forEach(e => {
        if(e){
          arr.push(e.nameCN)
        }
      });
      return arr.join(',')
    }
  },
  methods: {
  	popContact(event, item, id, position) {
      this.$emit("popContact", event, item, id, position);
    },
    changeStatus(item,status){
      this.$emit('changeStatus', item, status)
    },
    modiShipping(item){
      this.$emit('modiShipping', item)
    },
    delShipping(item){
      this.$emit('delShipping', item)
    }
  }
};
</script>

<style lang="less" scoped>
.countrys-wrap{
  max-width: 500px;
  padding: 5px;
  line-height: 24px;
  max-height: 96px;
  overflow-y: auto;
}
</style>
